// extracted by mini-css-extract-plugin
export var close = "cookie-popup-module--close--b65b8";
export var container = "cookie-popup-module--container--5b7a1";
export var content = "cookie-popup-module--content--0a7f6";
export var overlay = "cookie-popup-module--overlay--f9d4f";